import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll the app main pane (and window) to top on route changes. */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Keep in-page anchors (e.g. /problems#problemset) working.
    if (hash) return;

    const main = document.getElementById('app-main-scroll');
    if (main) {
      main.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
